
import { useState } from "react";
import { HiOutlineSearch } from "react-icons/hi";
import { Link } from "react-router-dom";
import { FaCartPlus, FaHeart, FaRegUser } from "react-icons/fa";


function Header() {
  const [open, setOpen] = useState(false);
  return (
    <div className="bg-white">

      <header className="relative ">
        <Navbar />
        <BottomNavbar />
      </header>
    </div>
  );
}

const Navbar = () => {
  return (
    <div className="py-4 container mx-auto bg-white">
      <div className="flex  items-center justify-between ">
        <div className="flex-1 justify-start">
          <Link to={"/"} className="font-semibold text-3xl">
            MAK Electronics
          </Link>
        </div>
        <div className="flex flex-1 items-center justify-center border border-gray-300 max-w-md w-full rounded-md overflow-hidden">
          <HiOutlineSearch className="h-6 w-6 m-2" />
          <input
            className="border-none outline-none focus:outline-none max-w-md w-full h-10 font-light"
            placeholder="Search"
          />
          <button className="bg-primary text-white font-semibold text-sm h-10 px-5 rounded-r-md">
            Search
          </button>
        </div>

        <div className="flex flex-1 items-center justify-end space-x-2">
          <Link to={"/wishlist"}>
            <FaHeart className="h-5 w-5"/>
          </Link>
          <div className="h-5 w-px bg-black"></div>
          <div className="flex items-center space-x-3">
            <Link to={"/cart"} className="relative">
              <FaCartPlus className="h-5 w-5"/>
              <p className="absolute -top-1 -right-1 bg-hardPrimary text-[10px] text-white px-1 py-[0.5px] rounded-full">
                2
              </p>
            </Link>
            <div className="text-xs">
              <p className="font-normal">Shopping cart:</p>
              <p className="font-semibold">$549.00</p>
            </div>

            <Link to={'/login'}>
            <FaRegUser className="h-5 w-5"/>
            </Link>
          </div>
        </div>
      </div>
    </div>  
  );
};

const BottomNavbar = () => {
  return (
    <div className="bg-gray-800 text-white">
      <div className="container mx-auto">
        <div className="flex items-center justify-between py-5">
          <div className="space-x-7">
            <Link to={"/"}>Home</Link>
            <Link to={"/"}>Shop</Link>
            <Link to={"/about"}>About Us</Link>
            <Link to={"/"}>Contact Us</Link>
          </div>
          <div className="flex">
            <a href="tel:2468965851">(246) 896-5851</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
